export default __webpack_public_path__ + "static/reed-5-347232f0ee6c154c7b45fc8d69efda38.webp";